import React, { useState, useEffect } from 'react';
import { fetchScormFileDetails, deleteScormFileApi } from '../../apis/scormUpload';
import ScormProcess from './ScormProcess/ScormProcess';
import StartExtractionButton from './ScormUploads/StartExtractionButton';
import DeleteFileButton from './ScormUploads/DeleteFileButton';
import StatusBadge from '../StatusBadge';
import { deleteScormFile as deleteScormFileAction } from '../../store/slices/scormFilesSlice';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

// Helper to build a tree from flat file paths
// function buildTree(files) {
//     const root = {};
//     files.forEach((filePath) => {
//         const parts = filePath.replace(/^\\/, '').split(/\\|\//);
//         let current = root;
//         parts.forEach((part, idx) => {
//             if (!current[part]) {
//                 current[part] = idx === parts.length - 1 ? null : {};
//             }
//             if (idx < parts.length - 1) {
//                 current = current[part];
//             }
//         });
//     });
//     return root;
// }

// function getNodeByPath(tree, pathArr) {
//     let node = tree;
//     for (const part of pathArr) {
//         if (!node[part]) return null;
//         node = node[part];
//     }
//     return node;
// }

const ScormFileExplorer = ({ scormId = 1 }) => {
    const [fileDetails, setFileDetails] = useState(null);
    // const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const [currentPath, setCurrentPath] = useState([]);
    const dispatch = useDispatch();
    const handleStartExtraction = (updatedFile) => {
        setFileDetails(updatedFile);
    };
    useEffect(() => {
        setLoading(true);
        setError(null);
        Promise.all([fetchScormFileDetails(scormId)])
            .then(([detailsRes]) => {
                setFileDetails(detailsRes.data);
                setLoading(false);
                // setCurrentPath([]);
            })
            .catch(() => {
                setError('Failed to load file details or file list');
                setLoading(false);
            });
    }, [scormId]);

    // const tree = buildTree(files);
    // const node = getNodeByPath(tree, currentPath);

    const handleDelete = async () => {
        if (!window.confirm('Are you sure you want to delete this scorm file?')) return;
        try {
            await deleteScormFileApi(fileDetails.id);
            toast.success('Scorm file deleted successfully');
            setFileDetails(null);
            dispatch(deleteScormFileAction(fileDetails.id));
        } catch (err) {
            toast.error('Failed to delete scorm file: ' + err);
        }
    };

    // Separate folders and files

    return (
        <div className="container py-4">
            <div className="card border-0 shadow-sm">
                <div className="card-body p-4 bg-light-gradient">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger text-center">{error}</div>
                    ) : fileDetails ? (
                        <>
                            {/* File name as header with icon and status */}
                            <div className="d-flex align-items-center mb-4 gap-3">
                                <i className="bi bi-file-earmark-zip text-primary" style={{ fontSize: 32 }} />
                                <h4 className="fw-semibold text-dark mb-0">{fileDetails.file_name}</h4>
                                <StatusBadge status={fileDetails.status} />
                            </div>
                            <div className="mb-4 d-flex gap-2">
                                <StartExtractionButton
                                    file={fileDetails}
                                    onStarted={handleStartExtraction}
                                    showButtonLabel={true}
                                />
                                <DeleteFileButton file={fileDetails} showButtonLabel={true} onDelete={handleDelete} />
                            </div>
                            {/* Content Extractions if any */}
                            {fileDetails.content_extractions && fileDetails.content_extractions.length > 0 && (
                                <div className="mb-4">
                                    <h6 className="fw-semibold mb-3">Content Extractions</h6>
                                    <div className="row g-3">
                                        {fileDetails.content_extractions.map((extraction) => (
                                            <div className="col-12 p-0" key={extraction.id}>
                                                <ScormProcess proc={extraction} />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default ScormFileExplorer;
